import Item from "../item";
import { ItemName } from "../item/item-types";

type CauldronIngredientsProps = {
    itemsToDisplay: ItemName[];
    setIngredients: React.Dispatch<React.SetStateAction<[ItemName, ItemName]>>;
};


const CauldronIngredients: React.FC<CauldronIngredientsProps> = ({
    itemsToDisplay,
    setIngredients
}) => {
    return (
        <div className='cauldron-ingredients'>
            {itemsToDisplay.map((item) => (
                <div className={`ingredient-item-${item}`} key={item}>
                    <button
                        className={`ingredient-button-${item}`}
                        onClick={() => {
                            setIngredients((prev) => {
                                if (prev[0] === ItemName.Empty) {
                                    return [item, prev[1]];
                                } else if (prev[1] === ItemName.Empty) {
                                    return [prev[0], item];
                                }
                                return prev;
                            });
                        }}
                    >
                        <Item key={item} itemName={item} />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default CauldronIngredients;